import { Component, ComponentInterface, Element, h, Host, JSX, Prop } from '@stencil/core';
import { getDataOnFromTheme, WorkbenchTheme } from '../../shared/themes';

/**
 * @slot - wb-list-group-item elements placed within the element
 */
@Component({
  tag: 'wb-list-group',
  styleUrl: 'list-group.scss',
  shadow: true,
})
export class ListComponent implements ComponentInterface {
  @Element()
  public el: HTMLWbListGroupElement;

  /**
   * The colour scheme
   * @deprecated Use `data-on` attribute instead
   */
  @Prop({ reflect: true })
  public theme?: WorkbenchTheme;

  /** set to true to hide outer border of element */
  @Prop({ reflect: true })
  public hideBorder: boolean = false;

  public render(): JSX.Element {
    return (
      <Host class="wb-list-group" role="list" data-on={getDataOnFromTheme(this.el, this.theme)}>
        <slot />
      </Host>
    );
  }
}
